import type { LegSummaryJson } from '@this/src/domain/select_repository';

export type TravelModeIconType = 'jr' | 'air' | 'walk' | 'bus';

type SegmentLegForIcon = {
  name: string;
  type?: string | null;
  airline_name?: string | null;
  airlineName?: string | null;
};

export type SegmentForIcon = {
  legs: SegmentLegForIcon[];
};

const ICON_PRIORITY: Record<TravelModeIconType, number> = {
  air: 4,
  jr: 3,
  bus: 2,
  walk: 1
};

const legToIconType = (leg: SegmentLegForIcon): TravelModeIconType => {
  if (leg.airline_name || leg.airlineName) {
    return 'air';
  }
  if (leg.type === 'bus') {
    return 'bus';
  }
  if (leg.type === 'walk' || leg.name === '徒歩') {
    return 'walk';
  }
  return 'jr';
};

const summaryTypeToIconType = (type: string): TravelModeIconType | null => {
  if (type === 'air' || type === 'evo_air') {
    return 'air';
  }
  if (type === 'jr' || type === 'shin' || type === 'express' || type === 'train') {
    return 'jr';
  }
  if (type === 'walk') {
    return 'walk';
  }
  if (type === 'bus') {
    return 'bus';
  }
  return null;
};

export const resolveTravelModeIconType = (
  type: string,
  legSummary?: LegSummaryJson,
  segment?: SegmentForIcon
): TravelModeIconType => {
  if (legSummary?.name === '徒歩') {
    return 'walk';
  }

  const directType = summaryTypeToIconType(type);
  if (directType) {
    return directType;
  }

  if ((type === 'before' || type === 'after') && legSummary && segment) {
    const legs = legSummary.indexes
      .map(index => segment.legs[Number(index) - 1])
      .filter((leg): leg is SegmentLegForIcon => leg != null);

    let best: TravelModeIconType = 'walk';
    let bestPriority = 0;
    legs.forEach(leg => {
      const iconType = legToIconType(leg);
      const priority = ICON_PRIORITY[iconType];
      if (priority > bestPriority) {
        best = iconType;
        bestPriority = priority;
      }
    });
    return best;
  }

  return 'jr';
};
